export const fetchProductReviews = async (id, limit, page, clientId) => {
   try {
      const response = await fetch(
         `https://plenum.digifiservices.se/prod/vb-proxy/api/product-reviews/${id}?clientId=${clientId}&page=${page}&pageSize=${limit}`,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
            },
         }
      )
      return await response.json()
   } catch (error) {
      console.error(error)
   }
}

export const sendQuestionRequest = async payload => {
   const baseUrl =
      'https://plenum.digifiservices.se/prod/vb-proxy/api/product-reviews/questions/create'
   try {
      const response = await fetch(baseUrl, {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json',
         },
         body: JSON.stringify(payload),
      })
      return response
   } catch (error) {
      console.error('Error:', error)
      // Catch and rethrow error
      throw error
   }
}